<template>
  <div class="page-container tags-page">
    <portal to="page-name">Tags</portal>
    <div class="card card-page">
      <div class="card-header">
        <h1 class="card-title">Tags</h1>
      </div>
      <div class="card-body">
        <div class="columns">
          <div class="column col-4 col-sm-12">
            <label for="type" class="form-label">Tipo</label>
            <select id="type" class="form-select" v-model="filter.type">
              <option value="">Todos os tipos</option>
              <option v-for="(text, value) in tagType.types" :value="value" :key="value">
                {{ text }}
              </option>
            </select>
          </div>
          <div class="column form-group">
            <label for="type" class="form-label">Pesquisar</label>
            <div class="input-group">
              <input
                type="text"
                class="form-input"
                v-model="filter.search"
                placeholder="Informe parte do nome para pesquisar..."
              >
              <button class="btn btn-neutral btn-action input-group-btn btn-icon" tabindex="-1">
                <fa-icon :icon="['fal', 'search']"/>
              </button>
            </div>
          </div>
          <div class="column col-auto" style="align-self: flex-end">
            <button class="btn btn-primary btn-icon btn-icon-left mb-2"
                    @click="create">
              <fa-icon :icon="['fal', 'plus']"/>
              Nova tag
            </button>
          </div>
        </div>
        <div class="loading loading-lg mt-2" v-if="loading"/>
        <template v-else>
          <template v-if="data.items.length === 0">
            <div class="empty mt-2">
              <div class="empty-icon">
                <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
              </div>
              <p class="empty-title h5">Tags</p>
              <p class="empty-subtitle">
                Nenhuma tag encontrada. Verifique os filtros para realizar novas buscas
              </p>
            </div>
          </template>
          <template v-else>
            <table class="table table-striped table-hover">
              <thead>
              <tr>
                <th class="hide-sm" style="width:40px">#</th>
                <th>Nome</th>
                <th class="text-left">Tipo</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in data.items" :key="i">
                <td class="hide-sm">{{ i + 1 }}</td>
                <td>
                  <router-link :to="editLink(item)">{{ item.name }}</router-link>
                </td>
                <td>{{ tagType.getName(item.type) }}</td>
                <td class="text-right">
                  <button class="btn btn-sm btn-action btn-icon btn-secondary mr-1"
                          :disabled="deleting"
                          @click="edit(item)">
                    <fa-icon :icon="['fal', 'pencil']"></fa-icon>
                  </button>
                  <button class="btn btn-sm btn-action btn-icon btn-error"
                          :class="{loading: deleting && idx === i}"
                          :disabled="deleting"
                          @click="remove(item, i)">
                    <fa-icon :icon="['fal', 'times']"></fa-icon>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import * as tagType from 'src/data/tag-types';
import { DELETE_TAG } from '@/data/actions/modules/general';

export default {
  data() {
    return {
      debounceTimeout: null,
      loading: false,
      deleting: false,
      idx: null,
      tagType,
      filter: {
        type: '',
        search: '',
      },
      data: {
        hasMore: false,
        items: [],
      },
    };
  },
  watch: {
    filter: {
      handler() {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(this.load, 600);
      },
      deep: true,
    },
  },
  computed: {
    canAccessRemove() {
      if (DELETE_TAG) {
        return this.$can(DELETE_TAG);
      }
      return true;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;

      const params = {
        active: true,
      };

      if (this.filter.search.trim().length > 0) {
        params.search = this.filter.search;
      }

      this.$http.get('/tags', { params })
        .then(({ data }) => {
          this.data = data;
        })
        .catch(() => {
          this.$toast.error('Ocorreu um erro ao carregar os dados.');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      this.$router.push('/settings/tags/create');
    },
    edit(item) {
      this.$router.push(`/settings/tags/${item.id}/edit`);
    },
    editLink(item) {
      return `/settings/tags/${item.id}/edit`;
    },
    remove(item, i) {
      if (!this.canAccessRemove) {
        this.$toast.show('Acesso não autorizado!', { type: 'error' });
        return;
      }

      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente excluir esta tag?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              this.deleting = true;
              this.idx = i;
              close();
              this.$http
                .delete(`/tags/${item.id}`)
                .then(() => {
                  this.data.items.splice(i, 1);
                })
                .catch(() => {
                  this.$toast.error('Ocorreu um erro. Tente novamente!');
                })
                .finally(() => {
                  this.deleting = false;
                });
            },
          },
        ],
      });
    },
  },
};
</script>
